// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0

export function isGroupImmediateSubmit(group: string) {
  // TODO: Other methods might also benefit from this.
  return group === "code"
}
